import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SEO from "@/components/SEO";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/admin";

  useEffect(() => {
    if (user && user !== false) {
      nav(from, { replace: true });
    }
  }, [user, from, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    const ok = await login(email, password);
    setLoading(false);
    if (ok) nav(from, { replace: true });
    else setErr("Email ose fjalëkalim i pasaktë");
  };

  return (
    <>
      <SEO title="Admin · Hyr" noindex />
      <section className="bg-bg">
        <div className="container-akm flex min-h-[70vh] items-center justify-center py-12">
          <form onSubmit={submit} className="w-full max-w-sm rounded-xl border border-line bg-white p-7 shadow-card" data-testid="admin-login-form">
            <Link to="/" className="mb-6 flex items-center">
              <img src="/akomoda-logo-dark.png" alt="Akomoda" className="h-9 w-auto" />
            </Link>
            <h1 className="font-display text-xl font-bold text-ink">Hyr në Admin</h1>
            <p className="mt-1 text-sm text-slate2">Vetëm për administratorët.</p>

            <div className="mt-5 space-y-3">
              <div>
                <label className="block text-sm font-medium text-ink">Email</label>
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  className="mt-1.5 w-full rounded-md border border-line bg-white px-3 py-2 text-sm text-ink outline-none focus:border-[#FF7A00] focus:ring-2 focus:ring-[#FF7A00]/20"
                  data-testid="admin-email" />
              </div>
              <div>
                <label className="block text-sm font-medium text-ink">Fjalëkalimi</label>
                <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                  className="mt-1.5 w-full rounded-md border border-line bg-white px-3 py-2 text-sm text-ink outline-none focus:border-[#FF7A00] focus:ring-2 focus:ring-[#FF7A00]/20"
                  data-testid="admin-password" />
              </div>
            </div>

            {err && <div className="mt-3 rounded-md border border-[#FECACA] bg-[#FEF2F2] p-2.5 text-sm text-[#991B1B]" data-testid="admin-login-error">{err}</div>}

            <button type="submit" disabled={loading} className="btn-primary mt-5 w-full justify-center disabled:opacity-60" data-testid="admin-login-submit">
              {loading ? "Duke hyrë…" : "Hyr"}
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
